"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_virtualized_1 = require("@vidazoo/ui-virtualized");
var classnames_1 = require("classnames");
var DataGrid = /** @class */ (function (_super) {
    tslib_1.__extends(DataGrid, _super);
    function DataGrid(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.getColumnsWidth = function () {
            var _a = _this.props, columnWidth = _a.columnWidth, headersCount = _a.headersCount;
            var columnsWidth = {};
            for (var i = 0; i < headersCount; i++) {
                columnsWidth[i] = columnWidth;
            }
            return columnsWidth;
        };
        _this.onColumnResize = function (index, width) {
            var _a, _b;
            var useColumnsWidthState = _this.props.useColumnsWidthState;
            useColumnsWidthState && _this.setState(tslib_1.__assign({}, _this.state, { columnsWidth: tslib_1.__assign({}, _this.state.columnsWidth, (_a = {}, _a[index] = width, _a)) }));
            _this.props.onColumnResize && _this.props.onColumnResize(tslib_1.__assign({}, (useColumnsWidthState ? _this.state : _this.props).columnsWidth, (_b = {}, _b[index] = width, _b)));
        };
        _this.setFreezeColumn = function (e) {
            var onFreezeColumnChange = _this.props.onFreezeColumnChange;
            var checked = e.target.checked;
            var value = Number(e.target.value);
            onFreezeColumnChange && onFreezeColumnChange(checked, value);
            _this.setState(tslib_1.__assign({}, _this.state, { freezeColumnIndex: checked ? value : -1 }));
        };
        _this.onRenderRow = function (index, viewportIndex) {
            var _a = _this.props, renderRow = _a.renderRow, useColumnsWidthState = _a.useColumnsWidthState;
            var freezeColumnIndex = _this.state.freezeColumnIndex;
            return renderRow(index, viewportIndex, (useColumnsWidthState ? _this.state : _this.props).columnsWidth, freezeColumnIndex, _this.setFreezeColumn);
        };
        _this.onRenderHeader = function (scrollTop, scrollLeft) {
            var _a = _this.props, renderHeader = _a.renderHeader, useColumnsWidthState = _a.useColumnsWidthState;
            var freezeColumnIndex = _this.state.freezeColumnIndex;
            if (renderHeader) {
                return renderHeader(scrollTop, scrollLeft, (useColumnsWidthState ? _this.state : _this.props).columnsWidth, _this.setFreezeColumn, freezeColumnIndex);
            }
        };
        _this.onRenderFooter = function (scrollTop, scrollLeft) {
            var _a = _this.props, renderFooter = _a.renderFooter, useColumnsWidthState = _a.useColumnsWidthState;
            var freezeColumnIndex = _this.state.freezeColumnIndex;
            if (renderFooter) {
                return renderFooter(scrollTop, scrollLeft, (useColumnsWidthState ? _this.state : _this.props).columnsWidth, _this.setFreezeColumn, freezeColumnIndex);
            }
        };
        _this.state = {
            freezeColumnIndex: typeof props.freezeColumnIndex === "number" ? props.freezeColumnIndex : -1,
            columnsWidth: props.columnsWidth || _this.getColumnsWidth()
        };
        return _this;
    }
    DataGrid.prototype.render = function () {
        var _a = this.props, enableColumnResizing = _a.enableColumnResizing, rowHeight = _a.rowHeight, className = _a.className, onBeforeScrollEnd = _a.onBeforeScrollEnd, useColumnsWidthState = _a.useColumnsWidthState, overscanItems = _a.overscanItems, itemsCount = _a.itemsCount, theme = _a.theme, extraData = _a.extraData, viewportHeight = _a.viewportHeight, useStickyScrollbar = _a.useStickyScrollbar, externalRef = _a.externalRef;
        var freezeColumnIndex = this.state.freezeColumnIndex;
        var classes = classnames_1.default(theme.dataGrid, className);
        var columnsWidth = useColumnsWidthState ? this.state.columnsWidth : this.props.columnsWidth;
        return (React.createElement(ui_virtualized_1.Table, { ref: externalRef, className: classes, extraData: tslib_1.__assign({}, this.state, { columnsWidth: columnsWidth, extraData: extraData }), onColumnResize: this.onColumnResize, renderHeader: this.onRenderHeader, renderFooter: this.onRenderFooter, renderRow: this.onRenderRow, enableColumnResizing: enableColumnResizing, freezeColumnIndex: freezeColumnIndex, onBeforeScrollEnd: onBeforeScrollEnd, viewportHeight: viewportHeight, overscanItems: overscanItems, itemsCount: itemsCount, rowHeight: rowHeight, useStickyScrollbar: useStickyScrollbar }));
    };
    DataGrid.defaultProps = {
        enableColumnResizing: true,
        columnWidth: 250,
        rowHeight: 41,
        viewportHeight: "100%",
        useColumnsWidthState: true
    };
    return DataGrid;
}(React.Component));
exports.default = DataGrid;
